import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 17-bin
 * @see {GlyphIcon}
 */
const TrashIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M7,26a2.00006,2.00006,0,0,0,2,2H23a2.00006,2.00006,0,0,0,2-2V10H7ZM20,14a1,1,0,0,1,2,0V24a1,1,0,0,1-2,0Zm-5,0a1,1,0,0,1,2,0V24a1,1,0,0,1-2,0Zm-5,0a1,1,0,0,1,2,0V24a1,1,0,0,1-2,0ZM26,6V8H6V6A1,1,0,0,1,7,5h6V4a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1V5h6A1,1,0,0,1,26,6Z";
	}
}

export default TrashIcon;